import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils';
export const Container = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('flex size-[30px] flex-shrink-0 items-center justify-center rounded-full border-[3px] border-white shadow-xs', className)} {...props} data-sentry-component="Container" data-sentry-source-file="CheckCircleUI.tsx">
      {children}
    </div>;
};
export const Icon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none" data-sentry-element="svg" data-sentry-component="Icon" data-sentry-source-file="CheckCircleUI.tsx">
      <path d="M13.0598 0.776258C13.5964 1.25325 13.6447 2.07495 13.1677 2.61156L6.23441 10.4116C5.98771 10.6891 5.6341 10.8479 5.26277 10.8479C4.89145 10.8479 4.53784 10.6891 4.29114 10.4116L0.824475 6.51156C0.347482 5.97495 0.395817 5.15325 0.932435 4.67626C1.46905 4.19926 2.29075 4.2476 2.76774 4.78422L5.26277 7.59113L11.2245 0.884217C11.7015 0.347599 12.5232 0.299264 13.0598 0.776258Z" fill="white" data-sentry-element="path" data-sentry-source-file="CheckCircleUI.tsx" />
    </svg>;
};
export const CheckCircleUI = {
  Container,
  Icon
};